import React from "react";
import { observer } from "mobx-react-lite";
import EventPass from "./EventPass";
import AppleFooter from "../components/AppleFooter";

const AppleEventPass = observer(({store}) => {
  if (typeof store === "string"){
    store = JSON.parse(store);
  }
  const data = store?.eventTicket;

  return (
    <EventPass
      store={{
        data,
        minHeight: "400px",
        footer: <AppleFooter barcodeType={data?.barcodeType} mobileWalletCode={data?.mobileWalletCode} />
      }}
    />
  );
});

export default AppleEventPass;
